import { useCallback, useEffect, useRef, useState } from 'react';

/** A late policy response supplies an untouched form's default, never a new
 * decision over a scheduling mode the operator already chose. */
export function useBookingEntryMode(
  bookingMode: string | undefined,
  eligible: boolean,
  policyScope?: string | null,
) {
  const [offerMode, setOfferMode] = useState(false);
  const [userTouched, setUserTouched] = useState(false);
  const defaultConsumed = useRef(false);
  const userChoseMode = useRef(false);
  const previousScope = useRef(policyScope);
  const chooseOfferMode = useCallback((offer: boolean) => {
    defaultConsumed.current = true;
    userChoseMode.current = true;
    setUserTouched(true);
    setOfferMode(offer);
  }, []);
  useEffect(() => {
    if (previousScope.current !== policyScope) {
      previousScope.current = policyScope;
      if (!userChoseMode.current) defaultConsumed.current = false;
    }
    if (!defaultConsumed.current && bookingMode !== undefined && eligible) {
      defaultConsumed.current = true;
      setOfferMode(eligible && bookingMode === 'OFFER');
    }
    if (!eligible) setOfferMode(false);
  }, [bookingMode, eligible, policyScope]);
  return [offerMode, chooseOfferMode, userTouched] as const;
}
